import { Maybe } from '@/types/general'
import EntryRepository from './entry-repository'
import Entry from './entry-model'

/**
 * Worker to hydrate stale entry data
 */
class EntryHydrator {
    private updateCallback?: (entryId: string) => Promise<any>

    public async start(callback?: (entryId: string) => Promise<any>): Promise<void> {
        if (callback) {
            this.updateCallback = callback
        }
        await this.run()
    }

    private async getNext(): Promise<Maybe<Entry>> {
        const entries = await EntryRepository.fetchStale()
        return entries.length > 0 ? entries[0] : undefined
    }

    private async run(): Promise<void> {
        if (!this.updateCallback) {
            throw Error('No callback defined when hydrating entry data')
        }

        const entry = await this.getNext()
        if (entry) {
            await this.updateCallback(entry.id!)
            await this.run()
        }
    }
}

export default new EntryHydrator()
